<template>
  <div class="flex justify-between q-px-md items-center">
    <div class="text-center q-pa-none ellipsis q-dialog__title">
      {{ header }}
    </div>
    <div>
      <slot />
      <q-btn
        v-if="closable"
        flat
        round
        style="height: 30px; width: 30px"
        class="bg-white"
        color="grey"
        size="sm"
        @click="emit('onClose')"
        :icon="tabOutlineX"
        v-close-popup
      />
    </div>
  </div>
</template>

<script setup>
import { tabOutlineX } from 'quasar-extras-svg-icons/tabler-icons-v3';

defineProps({
  header: String,
  closable: {
    type: Boolean,
    default: true,
  },
});
const emit = defineEmits(['onClose']);
</script>
